import { Component, OnInit } from "@angular/core";
import * as d3 from "d3";

@Component({
  selector: "app-range-slider",
  templateUrl: "./range-slider.component.html",
  styleUrls: ["./range-slider.component.css"],
})
export class RangeSliderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
